<template>
  <div class="login-box">
    <div class="title">密码登录</div>
    <el-form
      class="form"
      size="large"
      label-position="right"
      label-width="60px"
      :model="formData"
    >
      <el-form-item label="手机号" prop="mobile">
        <el-input placeholder="请输入手机号" v-model="formData.mobile" />
      </el-form-item>
      <el-form-item label="密码" prop="password">
        <el-input type="password" placeholder="请输入密码" v-model="formData.password" />
      </el-form-item>
    </el-form>
    <div class="footer">
      <el-button size="large" class="btn" type="danger" :disabled="disabled" :loading="loading" @click="onLogin">登录</el-button>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, defineEmits } from "vue";
import { login, getAreaList } from "../../provider/global";

const emits = defineEmits(['success'])

const formData = ref({
  mobile: '',
  password: ''
})

const loading = ref(false)
const disabled = computed(() => {
  return !formData.value.mobile || !formData.value.password
})

async function onLogin() {
  try {
    loading.value = true
    await login(formData.value)
    emits('success')
    await getAreaList()
  } finally {
    loading.value = false
  }
}

</script>

<style lang="less" scoped>
.login-box {
  background: #ffffff;
  padding: 30px 30px 40px 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .title {
    font-size: 18px;
  }
  .form {
    width: 100%;
    margin: 30px 0 0 0;
    ::v-deep(.el-form-item) {
      margin-bottom: 24px;
    }
  }
  .footer {
    width: 100%;
    .btn {
      width: calc(100% - 60px);
      margin-left: 60px;
    }
  }
}
</style>
